import { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import DropdownOption from "../Components/DropdownOption.jsx";
import { ReactComponent as IconSearch } from "../Images/icon_search.svg";

import { useLocation, useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import ApplyBtn from "../Components/ApplyBtn.jsx";
import MoreBtn from "../Components/MoreBtn.jsx";
import Layout from "../Layout/Layout.jsx";
import Pagination from "../Layout/Pagination.jsx";
import AlarmApply from "../Modals/AlarmApply.jsx";
import "../Styles/component.css";
import "../Styles/global.css";
import "../Styles/lists.css";
import { postJson } from "../Utils/apiUtils.js";
import { showToast } from "../Utils/variables.js";

const NoticeManageContent = () => {
  const location = useLocation();
  const [total_notice, setTotal_notice] = useState(0);
  const [notice_list, setNotice_list] = useState([]);
  const navigate = useNavigate();

  const [page, setPage] = useState(1);
  const offset = 10;

  const [searchTitle, setSearchTitle] = useState("");
  const [status, setStatus] = useState(null);
  const [popupStatus, setPopupStatus] = useState(null);
  const [nation, setNation] = useState("");
  const [noticeId, setNoticeId] = useState(null);

  const [clickDelete, setClickDelete] = useState(false);
  const [clickInput, setClickInput] = useState(false);
  const lastNoticeRequestKey = useRef(null);
  const previousFilterKey = useRef(null);

  const getNoticeList = async () => {
    try {
      let cCode = "";
      if (nation === "국내") cCode = "kr";
      else if (nation === "해외") cCode = "99";
      else if (nation === "전체") cCode = "00";
      const body = {
        page: page,
        offset: offset,
        searchTitle: searchTitle,
        status: status,
        popupStatus: popupStatus,
        cCode: cCode,
      };

      const data = await postJson("/dashboard/notice/getList", body, navigate);

      if (data.code === 200) {
        setTotal_notice(data.data.count);
        setNotice_list(data.data.rows);
      }
    } catch (error) {
      console.log("공지사항 리스트 가져오기 중 에러:", error);
      throw error;
    }
  };

  const handleDeleteNotice = async (noticeId) => {
    try {
      const body = { noticeId: noticeId };
      const data = await postJson("/dashboard/notice/delete", body, navigate);

      if (data.code === 200) {
        window.location.reload();
      }
    } catch (error) {
      console.log("공지사항 삭제 중 에러:", error);
      throw error;
    }
  };

  useEffect(() => {
    const filterKey = JSON.stringify({ status, popupStatus, nation });
    const filtersChanged = previousFilterKey.current !== filterKey;
    previousFilterKey.current = filterKey;

    if (filtersChanged && page !== 1) {
      return;
    }

    const requestKey = JSON.stringify({ page, status, popupStatus, nation });

    if (lastNoticeRequestKey.current === requestKey) {
      return;
    }

    lastNoticeRequestKey.current = requestKey;
    getNoticeList();
  }, [page, status, popupStatus, nation]);

  useEffect(() => {
    setPage(1);
  }, [status, popupStatus, nation]);

  useEffect(() => {
    if (location.state?.toast_enable) {
      showToast("공지사항 등록이 완료되었습니다.", "success");
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  return (
    <div>
      {/* 공지사항 박스 */}
      {clickDelete && (
        <AlarmApply
          title="항목을 삭제하시겠습니까?"
          subtitle="삭제하면 앱과 대시보드 내에서 해당 데이터가 영구적으로 사라집니다."
          handleApply={() => handleDeleteNotice(noticeId)}
          handleClickX={() => setClickDelete(false)}
        />
      )}
      <NoticeBox>
        <div className="title-in-box">공지사항 관리</div>
        {/* 검색창 | 드롭다운 옵션 3개 | 등록하기 버튼 */}
        <div className="hrz-wrapper" style={{ marginTop: "20px" }}>
          {/* 검색창 */}
          <div
            className="searchBox"
            style={{ boxShadow: clickInput ? "inset 0 0 0 1px #1167ed" : "" }}
          >
            <input
              type="text"
              placeholder="제목"
              onChange={(e) => setSearchTitle(e.target.value)}
              onClick={() => setClickInput(true)}
              onBlur={() => setClickInput(false)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  getNoticeList();
                }
              }}
            />
            <IconSearch style={{ cursor: "pointer" }} onClick={getNoticeList} />
          </div>

          {/* 드롭다운 옵션 */}
          <div style={{ display: "flex", marginLeft: "auto" }}>
            <DropdownOption
              title="앱 노출 여부"
              dropdown_list={["노출", "미노출"]}
              optionChange={(value) =>
                setStatus(value === "노출" ? 1 : value === "미노출" ? 0 : null)
              }
            />
            <DropdownOption
              title="팝업 여부"
              dropdown_list={["팝업", "미팝업"]}
              optionChange={(value) =>
                setPopupStatus(
                  value === "팝업" ? 1 : value === "미팝업" ? 0 : null
                )
              }
            />
            <DropdownOption
              title="노출 국가"
              dropdown_list={["전체", "국내", "해외"]}
              optionChange={(value) => setNation(value)}
            />

            {/* 등록하기 버튼 */}
            <ApplyBtn addr="/notice/apply" />
          </div>
        </div>

        {/* 전체 공지사항 건수 */}
        <div
          className="hrz-wrapper"
          style={{ marginTop: "30px", color: "#000000" }}
        >
          전체 {total_notice}건
        </div>

        {/* 공지사항 리스트 */}
        <div className="listArea" style={{ marginTop: "10px" }}>
          {/* 라벨 */}
          <div
            className="list_titleBar"
            style={{
              gridTemplateColumns:
                "100px 140px 330px 140px 140px 220px 220px 210px",
            }}
          >
            <p className="center">NO</p>
            <p className="leftalign">팝업 이미지</p>
            <p className="leftalign">제목</p>
            <p className="leftalign">앱 노출 여부</p>
            <p className="leftalign">팝업 여부</p>
            <p className="leftalign">팝업 노출 기간</p>
            <p className="leftalign">등록일</p>
            <p className="leftalign">노출 국가</p>
          </div>

          {/* 데이터 */}
          {notice_list.slice(0, 10).map((data) => (
            <NoticeData
              key={data.noticeId}
              rownum={data.rownum}
              popupImage={data.popupImage}
              title={data.title}
              status={data.status}
              popupStatus={data.popupStatus}
              startTime={data.startTime}
              endTime={data.endTime}
              regTime={data.regTime}
              cCode={data.cCode}
              noticeId={data.noticeId}
              handleDeleteNotice={handleDeleteNotice}
              setClickDelete={setClickDelete}
              setNoticeId={setNoticeId}
            />
          ))}
        </div>

        {/* 페이징 Bar*/}
        <Pagination
          totalPages={total_notice === 0 ? 1 : Math.ceil(total_notice / 10)}
          currentPage={page}
          onPageChange={(pageNum) => setPage(pageNum)}
        />
      </NoticeBox>
    </div>
  );
};

const NoticeData = ({
  rownum,
  popupImage,
  title,
  status,
  popupStatus,
  startTime,
  endTime,
  regTime,
  cCode,
  noticeId,
  setClickDelete,
  setNoticeId,
}) => {
  let nation = "";
  if (cCode === "kr") nation = "국내";
  else if (cCode === "99") nation = "해외";
  else if (cCode === "00") nation = "전체";

  let _status = status === 0 ? "미노출" : "노출";
  let _popupStatus = popupStatus === 0 ? "미팝업" : "팝업";

  const popupDate = startTime ? startTime + " ~ " + endTime : "";
  return (
    <div
      className="list_contentBar"
      style={{
        gridTemplateColumns:
          "100px 140px 330px 140px 140px 220px 220px 158px 52px",
      }}
    >
      <p className="center">{rownum?.toLocaleString()}</p>
      <div className="leftalign">
        {popupImage ? (
          <div className="emptyImage">
            <img
              src={`${process.env.REACT_APP_IMAGE_BASE_URL}/${popupImage}`}
              style={{ width: "100%", height: "100%" }}
            />
          </div>
        ) : (
          <div className="emptyImage" />
        )}
      </div>
      <div className="scrollName leftalign">
        <p style={{ whiteSpace: "nowrap" }}>{title}</p>
      </div>
      <p className="leftalign">{_status}</p>
      <p className="leftalign">{_popupStatus}</p>
      <p className="leftalign">{popupDate}</p>
      <p className="leftalign">{regTime}</p>
      <p className="leftalign">{nation}</p>
      <div className="center">
        <MoreBtn
          option1="수정"
          option2="삭제"
          option1Addr={`/notice/edit/${noticeId}`}
          optionClickDelete={() => {
            setNoticeId(noticeId);
            setClickDelete(true);
          }}
        />
      </div>
    </div>
  );
};

const NoticeBox = styled.div`
  width: 1500px;
  height: auto;
  padding: 30px;
  background-color: #ffffff;
  border-radius: 20px;
  margin: 30px;
`;

const NoticeManage = () => {
  return <Layout page={<NoticeManageContent />} />;
};

export default NoticeManage;
